import { render, staticRenderFns } from "./InfoQuantityTag.vue?vue&type=template&id=85968218&scoped=true"
import script from "./InfoQuantityTag.vue?vue&type=script&lang=js"
export * from "./InfoQuantityTag.vue?vue&type=script&lang=js"
import style0 from "./InfoQuantityTag.vue?vue&type=style&index=0&id=85968218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85968218",
  null
  
)

export default component.exports